import { Timeline as MantineTimeline } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import type { CustomTimelineFactory, IProps } from "./timeline.types";
import TimelineItem from "./timeline-item";
import styles from "./timeline.module.scss";

/**
 * Timeline component for displaying a list of events in chronological order.
 */
const Timeline = componentWrapper<CustomTimelineFactory, IProps>("Timeline", (props, ref) => {
    return (
        <MantineTimeline
            ref={ref}
            classNames={{
                root: styles["root"],
                item: styles["item"],
                itemBody: styles["itemBody"],
                itemContent: styles["itemContent"],
                itemBullet: styles["itemBullet"],
                itemTitle: styles["itemTitle"],
            }}
            {...props}
        />
    );
});

Timeline.Item = TimelineItem;

export default Timeline;
